__turbopack_context__.v({
  "person-card-link": "_6v1WYa_person-card-link",
  "results-list": "_6v1WYa_results-list",
  "results-list-header": "_6v1WYa_results-list-header",
});
